import {
  getDictionaryParamValues,
  getFormValue,
  getIsMotorFromSelector,
  getQuestion,
  setDictionary,
  setMessageVisibility,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  RouteEnum,
} from 'app/shared/enums';
import { DictService } from 'app/services/dict.service';
import { useExtendedInfoEkspertDictionary } from 'app/services/env.service';
import { isMotorInfoEkspertDisable } from 'app/services/env.service';
import drivingWheelLocation from './drivingWheelLocation';

const getValue = (field: FieldsEnum) => {
  const isCepikModal = window.location.pathname.includes(
    RouteEnum.COMPARE_CEPIK_DATA
  );

  return getFormValue(
    field,
    ...(isCepikModal ? [FormsEnum.CompareCepikDataForm] : [])
  );
};

const hasModelIe = () => String(getValue(FieldsEnum.CarModelIe)) !== '-1';
const hasVersionEt = () => getValue(FieldsEnum.CarVersionEt) !== 'no_car_type';
const hasVersionIe = () => String(getValue(FieldsEnum.CarVersionIe)) !== '-1';

const isVersionIeInvalid = () => !hasVersionIe() && !hasVersionEt();
const isModelIeInvalid = () => !hasModelIe() && !hasVersionEt();

const carModelAndVersion = {
  onVersionEtChange() {
    const isInvalid = isVersionIeInvalid() || isModelIeInvalid();
    const isMotor = getIsMotorFromSelector();
    const isCepikModal: boolean = window.location.pathname.includes(
      RouteEnum.COMPARE_CEPIK_DATA
    );
    const formName = isCepikModal
      ? FormsEnum.CompareCepikDataForm
      : FormsEnum.CalculationForm;

    if (!isMotor) {
      setMessageVisibility({
        key: MessagesEnum.NoVersionEtWarning,
        visible: !isInvalid && !hasVersionEt(),
        formName,
      });

      setMessageVisibility({
        key: MessagesEnum.NoVersionIeAndEtError,
        visible: false,
        formName,
      });

      setMessageVisibility({
        key: MessagesEnum.NoVersionIeWarning,
        visible: false,
        formName,
      });

      if (useExtendedInfoEkspertDictionary) {
        setQuestionVisibility({
          key: FieldsEnum.CarShowLessRestrictedIeModels,
          visible: !hasVersionEt(),
          formName,
        });
      }
    } else {
      setMessageVisibility({
        key: MessagesEnum.NoVersionIeAndEtError,
        visible: !hasVersionEt(),
        formName,
      });

      setMessageVisibility({
        key: MessagesEnum.NoVersionEtError,
        visible: isMotorInfoEkspertDisable && !hasVersionEt(),
        formName,
      });
    }
  },

  onModelIeChange() {
    const isInvalid = isModelIeInvalid();
    const isCepikModal = window.location.pathname.includes(
      RouteEnum.COMPARE_CEPIK_DATA
    );
    const formName = isCepikModal
      ? FormsEnum.CompareCepikDataForm
      : FormsEnum.CalculationForm;

    const fieldsVisibility = [
      {
        key: MessagesEnum.NoModelAndVersionError,
        visible: isInvalid,
      },
      {
        key: MessagesEnum.NoVersionEtWarning,
        visible: !isInvalid && !hasVersionEt(),
      },
      {
        key: MessagesEnum.NoModelIeWarning,
        visible: !isInvalid && !hasModelIe(),
      },
      {
        key: MessagesEnum.NoVersionIeAndEtError,
        visible: false,
      },
      {
        key: MessagesEnum.NoVersionIeWarning,
        visible: false,
      },
    ];

    fieldsVisibility.forEach((field) =>
      setMessageVisibility({ ...field, formName })
    );

    setQuestionVisibility({
      key: FieldsEnum.CarVersionIe,
      visible: hasModelIe(),
      formName,
    });
  },

  onVersionIeChange() {
    const isInvalid = isVersionIeInvalid();
    const isMotor = getIsMotorFromSelector();
    const isCepikModal = window.location.pathname.includes(
      RouteEnum.COMPARE_CEPIK_DATA
    );
    const formName = isCepikModal
      ? FormsEnum.CompareCepikDataForm
      : FormsEnum.CalculationForm;

    if (!isMotor) {
      drivingWheelLocation.drivingWheelLocationChange();
    }

    const fieldsVisibility = [
      {
        key: MessagesEnum.NoVersionIeAndEtError,
        visible: isInvalid && hasModelIe(),
      },
      {
        key: MessagesEnum.NoVersionIeWarning,
        visible: !isInvalid && !hasVersionIe() && hasModelIe(),
      },
      {
        key: MessagesEnum.NoVersionEtWarning,
        visible: !isInvalid && !hasVersionEt(),
      },
    ];
    fieldsVisibility.forEach((field) =>
      setMessageVisibility({ ...field, formName })
    );
  },

  showLessRestrictedIeModelsChange() {
    const paramValues = getDictionaryParamValues({
      formName: FormsEnum.CalculationForm,
      answersDictionaryParams: getQuestion(FieldsEnum.CarModelIe)
        .answersDictionaryParams,
    });

    const params = JSON.parse(paramValues);

    DictService.getDictionary('infoekspert_models', params).then(
      ({ data: dictionary }) => {
        setDictionary({
          dictionaryKey: `${FieldsEnum.CarModelIe}_dictionary`,
          dictionary,
          formName: FormsEnum.CalculationForm,
        });
      }
    );
  },
};

export default carModelAndVersion;
